/* eslint-disable @typescript-eslint/no-type-alias */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Text", {
    enumerable: true,
    get: function() {
        return Text;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_default(require("react"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const componentMapping = {
    heading: "h1",
    navigation: "span",
    label: "span",
    text: "p",
    button: "span",
    block: "div"
};
const Text = /*#__PURE__*/ _react.default.forwardRef((param, ref)=>{
    let { children, variant = "text", size = "default", weight, component, className, color, ...props } = param;
    const Component = component !== null && component !== void 0 ? component : componentMapping[variant];
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const propsWithRef = {
        ...props,
        ref
    };
    return /*#__PURE__*/ _react.default.createElement(Component, {
        ...propsWithRef,
        className: _style.default.dynamic([
            [
                "1f14f0d640b4b6f8",
                [
                    color
                ]
            ]
        ]) + " " + (propsWithRef && propsWithRef.className != null && propsWithRef.className || "break ".concat(color != null ? "color" : "", " typography--").concat(variant, " typography--").concat(variant, "-").concat(size, " ").concat(className !== null && className !== void 0 ? className : "", " ").concat(weight != null ? "typography--".concat(weight) : "").trim() || "")
    }, children, /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "1f14f0d640b4b6f8",
        dynamic: [
            color
        ]
    }, ".break.__jsx-style-dynamic-selector{word-wrap:break-word;overflow-wrap:break-word}.color.__jsx-style-dynamic-selector{color:".concat(color, "}.typography--navigation.__jsx-style-dynamic-selector{font-size:.75rem;line-height:1rem;font-weight:500}.typography--text.__jsx-style-dynamic-selector{font-size:1rem;line-height:1.25rem;font-weight:400}.typography--text-small.__jsx-style-dynamic-selector{font-size:.875rem;line-height:1rem}.typography--text-extra-small.__jsx-style-dynamic-selector{font-size:.75rem;line-height:1rem}.typography--text-large.__jsx-style-dynamic-selector{font-size:1.125rem;line-height:1.5rem}.typography--label.__jsx-style-dynamic-selector{font-size:.75rem;line-height:1rem;font-weight:500;text-transform:uppercase;letter-spacing:.02em}.typography--label-small.__jsx-style-dynamic-selector{font-size:.625rem;line-height:1rem}.typography--heading.__jsx-style-dynamic-selector{font-size:1.25rem;line-height:1.5rem;font-weight:700}.typography--heading-small.__jsx-style-dynamic-selector{font-size:1.125rem;line-height:1.5rem}.typography--heading-large.__jsx-style-dynamic-selector{font-size:1.5rem;line-height:1.75rem}.typography--button.__jsx-style-dynamic-selector{font-size:.875rem;line-height:1.5rem;font-weight:700;text-transform:uppercase;letter-spacing:.02em}.typography--button-small.__jsx-style-dynamic-selector{font-size:.75rem;line-height:1rem}.typography--regular.__jsx-style-dynamic-selector{font-weight:400}.typography--medium.__jsx-style-dynamic-selector{font-weight:500}.typography--bold.__jsx-style-dynamic-selector{font-weight:700}")));
});
Text.displayName = "Text";

//# sourceMappingURL=Text.js.map